module.exports = __webpack_public_path__ + "img/cosmos.9cccbcc0.png";